/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ContactInputs */

const ja_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const en_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTACT`)
};

/**
* | output |
* | --- |
* | "CONTACT" |
*
* @param {Nav_ContactInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_contact = /** @type {((inputs?: Nav_ContactInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ContactInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_contact(inputs)
	return en_nav_contact(inputs)
});